import React, { createContext, useContext } from "react";

export const MlStatusRepositoryContext = createContext(null);

export const MlStatusRepositoryProvider = ({ repository, children }) => (
  <MlStatusRepositoryContext.Provider value={repository}>
    {children}
  </MlStatusRepositoryContext.Provider>
);

export const useMlStatusRepository = () =>
  useContext(MlStatusRepositoryContext);

export default MlStatusRepositoryContext;
